import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Icon, Segment, Table, Input, Divider, Card, Grid, Label } from 'semantic-ui-react';
import TargetLink from '../target-link';
import DiscountCodesSelector from '../discount-codes-selector';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const SHOPIFY_HELP_LINK = 'https://help.prestaShop.com/en/manual/discounts/create-discount-codes';
const DISCOUNT_HELP_LINK = 'https://help.dyzio.co/en/articles/5517378-prestaShop-integration';

const prestaShopLogoStyle = {
  height: '1.2em',
};

const iconMarginLeftStyle = {
  marginLeft: 5,
};

const buttonStyles = {
  width: 'auto',
};

class PrestaShopConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      discountCode: props.discountCode,
      commission: props.commission,
      isDiscountCodeEditing: false,
      isUrlEditing: false,
      isCommissionEditing: false,
      hidePrestaShopConfig: false,
      isUrlValid: true,
      isCommissionValid: true,
    };
  }

  persistPrestaShopSettings = async prestaShopSettings => {
    const { discountCode, commission } = prestaShopSettings;
    const { savePrestaShopSetting, reloadPrestaShopOrders } = this.props;

    if (discountCode || _.isEqual(discountCode, '')) {
      await savePrestaShopSetting(prestaShopSettings);
      reloadPrestaShopOrders();
      this.toggleDiscountCodeInputState();
    }

    if (commission) {
      const {
        isCommissionValid,
      } = this.state;
      if (isCommissionValid) {
        await savePrestaShopSetting(prestaShopSettings);
        reloadPrestaShopOrders();
        this.setState({
          isCommissionEditing: false,
        });
      }
    }
  }

  onDiscountCodeChange = (e, { value }) => this.setState({
    discountCode: value,
  });

  onCommisionChange = (e, { value }) => this.setState({
    commission: value,
    isCommissionValid: (_.toNumber(value) <= 100) && (_.toNumber(value) >= 0),
  });

  toggleDiscountCodeInputState = () => this.setState({
    isDiscountCodeEditing: !this.state.isDiscountCodeEditing,
  });

  toggleCommissionInputState = () => this.setState({
    isCommissionEditing: !this.state.isCommissionEditing,
  });

  togglePrestaShopConfig = () => this.setState({
    hidePrestaShopConfig: !this.state.hidePrestaShopConfig,
  });

  onDiscountCodeSelected = async dc => {
    const {
      discountCode,
    } = this.state;

    console.log(dc);

    const discountCodeArray = _.split(discountCode, ',');

    console.log(discountCodeArray);

    const isDiscountCodeSelected = _.find(discountCodeArray, item => (_.isEqual(item, dc)));
    console.log(isDiscountCodeSelected);

    let updatedDiscountCode = discountCode;

    if (!isDiscountCodeSelected) {
      if (discountCode) {
        updatedDiscountCode = `${discountCode},${dc}`;
      } else {
        updatedDiscountCode = dc;
      }
    }

    await this.persistPrestaShopSettings({ discountCode: updatedDiscountCode });

    this.setState({ discountCode: updatedDiscountCode });
  }

  onTagUnselected = tagId => {
    const { tags } = this.state;
    const newTags = _.reject(tags, ['id', tagId]);
    this.setState({
      tags: newTags,
    });
  }

  render() {
    const {
      discountCode,
      isDiscountCodeEditing,
      commission,
      isCommissionEditing,
      hidePrestaShopConfig,
      isCommissionValid,
    } = this.state;

    const { editable } = this.props;

    console.log(this.state);

    const commisionInputActionProps = {
      icon: isCommissionEditing ? 'save' : 'pencil',
      onClick: isCommissionEditing ? () => this.persistPrestaShopSettings({ commission }) : this.toggleCommissionInputState,
      disabled: isCommissionEditing && _.isEmpty(commission),
      color: isCommissionEditing ? 'pink' : 'green',
    };

    const discountCodeInputActionProps = {
      icon: isDiscountCodeEditing ? 'save' : 'pencil',
      onClick: isDiscountCodeEditing ? () => this.persistPrestaShopSettings({ discountCode }) : this.toggleDiscountCodeInputState,
      disabled: isDiscountCodeEditing && _.isEmpty(discountCode),
      color: isDiscountCodeEditing ? 'pink' : 'green',
    };

    return (
      <Segment>
        <Card.Content>
          <Grid columns="2">
            <Grid.Row>
              <Grid.Column verticalAlign="middle">
                <h3><img
                  style={prestaShopLogoStyle}
                  src="/icons/prestashop.svg"
                  alt="PrestaShop"
                /> PrestaShop configuration
                { editable && <TargetLink href={DISCOUNT_HELP_LINK} renderIf>
                  <Icon name="info circle" color="green" style={iconMarginLeftStyle} />
                </TargetLink>}
                </h3>
              </Grid.Column>
              <Grid.Column textAlign="right">
                { hidePrestaShopConfig
                  ? <Button floated="right" icon="chevron down" onClick={this.togglePrestaShopConfig} style={buttonStyles} />
                  : <Button floated="right" icon="chevron up" onClick={this.togglePrestaShopConfig} style={buttonStyles} />
                }
              </Grid.Column>
            </Grid.Row>
          </Grid>

        </Card.Content>
        <Divider />
        { editable && !hidePrestaShopConfig && <Card.Content>
          <p>
              Add a PrestaShop discount code and / or a shareable URL to this influencer.  These
              codes can be created and accessed in the 'Discounts' section of your PrestaShop
              account. <TargetLink href={SHOPIFY_HELP_LINK} renderIf>
                  Click here
            </TargetLink> to learn more.
            <br />
            <br />
            You can also add a Commission percentage,
            that will be applied to any sales the influencers makes,
            via this PrestaShop URL or discount code. The influencer will be able to see the commission
            they have earned when they log into Dyzio.
            <br />
            <br />
            All PrestaShop data linked to this code and URL will be available in your Dyzio PrestaShop report.
          </p>
        </Card.Content>}
        { !hidePrestaShopConfig &&
        <Table>
          <Table.Row>
            <Table.Cell width={2}>Discount Code</Table.Cell>
            { editable && <Table.Cell width={14}>
              <Input
                fluid
                type="string"
                onChange={this.onDiscountCodeChange}
                disabled={!isDiscountCodeEditing}
                defaultValue={discountCode}
                value={discountCode}
                action={discountCodeInputActionProps}
              />
            </Table.Cell>}
            { !editable && <Table.Cell width={14}>
              <Input
                fluid
                type="string"
                disabled={!editable}
                defaultValue={discountCode}
                value={discountCode}
              />
            </Table.Cell>}
          </Table.Row>
          <Table.Row>
            <Table.Cell width={2}>Commission %</Table.Cell>
            { editable && <Table.Cell width={14}>
              <Input
                fluid
                type="number"
                onChange={this.onCommisionChange}
                disabled={!isCommissionEditing}
                defaultValue={commission}
                value={commission}
                action={commisionInputActionProps}
                error={!isCommissionValid}
              />
              {
                (!isCommissionValid && commission) &&
                <Card.Content meta textAlign="center">
                  <Label color="red" basic><Icon name="ban" color="red" />Must be a percentage between 0 - 100</Label>
                </Card.Content>
              }
            </Table.Cell>}
            { !editable && <Table.Cell width={14}>
              <Input
                fluid
                type="number"
                disabled={!editable}
                defaultValue={commission}
                value={commission}
              />
            </Table.Cell>}
          </Table.Row>
        </Table>}
      </Segment>
    );
  }
}

PrestaShopConfig.propTypes = {
  discountCode: PropTypes.string.isRequired,
  commission: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired,
};

PrestaShopConfig.defaultProps = {
  editable: false,
};

export default PrestaShopConfig;



/** WEBPACK FOOTER **
 ** ./src/components/prestaShop-config/index.js
 **/